import React from "react";

/**
 * Forcibly sets the `checked` attribute on the input. So that pure CSS styling works if JavaScript is disabled (copying HTML).
 */
export const useForceHTMLInputCheckedAttribute = (inputRef: React.RefObject<HTMLInputElement>, checked: boolean): void => {
  React.useLayoutEffect(() => {
    const el = inputRef.current;

    if (!el) return;

    if (checked) {
      el.setAttribute("checked", "checked");
    } else if (el.checked) {
      el.removeAttribute("checked");
    }
  }, [inputRef.current, checked]);
};
